import { createSelector, createSlice } from '@reduxjs/toolkit';
import { fetchAclResources } from 'common/services/api/Acls/AclResources.thunk';
import { AclResource } from 'common/types/Entities';
import { clearEntitiesReducer,createProcessingEntityInitialState, createProcessingExtraReducers, ProcessingEntityState } from 'common/utils/sliceUtils/entitySliceUtils';
import { filterReducers } from 'common/utils/sliceUtils/filterSliceUtils';

type AclResourcesState = ProcessingEntityState<AclResource>;

type StateWithAclResources = { aclResources: AclResourcesState };

const initialState: AclResourcesState = createProcessingEntityInitialState<AclResource>();

const aclResourcesSlice = createSlice({
    name: 'aclResources',
    initialState,

    reducers: (create) => ({
        ...filterReducers,
        clearEntities: create.reducer(clearEntitiesReducer)
    }),

    extraReducers: builder => {
        createProcessingExtraReducers<AclResource>(builder, fetchAclResources);
    }
});

// eslint-disable-next-line no-restricted-syntax
export default aclResourcesSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters, clearEntities } = aclResourcesSlice.actions;
export const selectFilters = (state: StateWithAclResources) => state.aclResources.filters;
export const selectRawEntities = (state: StateWithAclResources) => state.aclResources.entities;
export const selectEntities = createSelector(
    [selectRawEntities],
    (entities) => entities.map(entity => ({
        ...entity,
        conditionsDisplay: entity.conditions?.join(', ') ?? ''
    }))
);
export const selectProcessing = (state: StateWithAclResources) => state.aclResources.processing;
export const selectError = (state: StateWithAclResources) => state.aclResources.error;
